import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { cancellationDetails } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetCancellationDetails = (props, enabled) => {
    const additional = useQueryRequestParams();
    const id = props.id || props.hero_user_id || props.device_serial;
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}subscription/backoffice/cancellation-details`, { ...additional, params: { ...props } }),
        queryKey: [cancellationDetails, id],
        enabled
    });
};
export default useGetCancellationDetails;
